import React from 'react';
import { BellIcon } from 'lucide-react';
import { NoticeSignupForm } from './NoticeSignupForm';

/** Page d'inscription aux alertes, affichée quand le visiteur n'a pas de session. */
export function NoticeSignup() {
  return <main className="bg-white" data-id="element-488" data-mp="258lyl7ao73fl">
      <div className="mx-auto max-w-[620px] px-5 py-14 lg:px-10 lg:py-20" data-id="element-489" data-mp="257u5q48gjjt0">
        <span className="grid h-12 w-12 place-items-center rounded-full bg-ville-sand text-ville-deep" aria-hidden="true" data-id="element-490" data-mp="20aankt8n2mvs">
          <BellIcon className="h-6 w-6" data-id="element-491" data-mp="1r9mb42yw8ul0" />
        </span>

        <h1 className="mt-5 text-3xl font-extrabold tracking-tight text-ville-navy lg:text-4xl" data-id="element-492" data-mp="1r8uhgxoux6xd">
          Recevoir les alertes citoyennes
        </h1>

        <div className="mt-4" data-id="element-493" data-mp="1hcrejpm6l49d">
          <NoticeSignupForm data-id="element-494" data-mp="1hdj007m2dllx" />
        </div>
      </div>
    </main>;
}